import '@angular/compiler';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';

// Note: loader import location set using "esmLoaderPath" within the output target config
import { defineCustomElements, setNonce } from 'hermes-frontlib-ng-01-dsinterno/loader';

const cspNonce = document
    .querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')
    ?.content;

try {
    await platformBrowser().bootstrapModule(AppModule);
    if (cspNonce) {
        setNonce(cspNonce);
    }

    defineCustomElements(globalThis as unknown as Window);
} catch (err: unknown) {
    console.error(err);
}
